let gaIds = [''];

const contentGroupHostingIndex = 2;
const contentGroupCompatibleProductIndex = 3;
const contentGroupPaymentModelIndex = 4;

function registerTrackerAndPluginVars(gaId, pluginId, pluginKey, buildNum, title = document.title) {
  if (typeof _ga === 'undefined') return;
  const trackerName = 'p' + pluginId;
  const prefix = trackerName + '.';
  if (gaId) {
    _ga('create', gaId, 'auto', trackerName);
  }
  setCustomVar(1, 'Plugin Key', pluginKey);
  setCustomVar(2, 'Plugin Version Build Number', buildNum.toString(10));

  if (gaId) {
    // anonymize IP address for all hits from this new tracker
    _ga(prefix + 'set', 'anonymizeIp', true);
    // register the pageview for just this new tracker
    _ga(prefix + 'send', 'pageview', {
      title,
    });
  }
}

// Marks an analytics event to be safe to forward to
// partner (developer of `pluginId`). All events executed in the
// callback will be also forwarded to the partner of the plugin ID/
// Note: For this to work `registerTrackerAndPluginVars` must have been
// initialized with the tracker name for the plugin
export function safeToForwardToPartner(pluginId, callback) {
  const trackerName = 'p' + pluginId;
  const prefix = trackerName + '.';

  gaIds.push(prefix);
  callback();
  gaIds = gaIds.filter(gaId => gaId !== prefix);
}

function unregisterTrackerAndPluginVars(gaId, pluginId) {
  if (typeof _ga === 'undefined') return;
  const trackerName = 'p' + pluginId;
  const prefix = trackerName + '.';
  if (gaId) {
    _ga(prefix + 'remove');
  }

  setCustomVar(1, 'Plugin Key', null);
  setCustomVar(2, 'Plugin Version Build Number', null);
}

export function trackPageView(url, skipAddlTrackers) {
  if (skipAddlTrackers) {
    _trackPageView(url);
  } else {
    gaIds.forEach(prefix => {
      _trackPageView(url, prefix);
    });
  }
}

function _trackPageView(url, prefix = '') {
  if (typeof _ga === 'undefined') return;
  _ga(prefix + 'set', 'page', url);
  _ga(prefix + 'send', 'pageview');
}

export function trackEvent(category, action, label, value, noninteraction) {
  if (typeof _ga === 'undefined') return;
  gaIds.forEach(prefix => {
    _ga(prefix + 'send', 'event', category, action, label, value, {
      nonInteraction: noninteraction,
    });
  });
}

function setContentGroup(index, name) {
  if (typeof _ga === 'undefined') return;
  gaIds.forEach(prefix => {
    _ga(prefix + 'set', 'contentGroup' + index, name);
  });
}

function setCustomVar(index, name, value) {
  if (typeof _ga === 'undefined') return;
  gaIds.forEach(prefix => {
    _ga(prefix + 'set', 'dimension' + index, value);
  });
}

export function markVendorPagesVisited() {
  setCustomVar(1, 'Has visited vendor pages', 'Yes');
}

export function markAdminPagesVisited() {
  setCustomVar(2, 'Has visited admin pages', 'Yes');
}

export function markHasLoggedIn() {
  setCustomVar(3, 'Has logged in', 'Yes');
}

export function markStatsPagesVisited() {
  setCustomVar(4, 'Has visited the admin analytics pages', 'Yes');
}

export function trackBuyButton(hostingType) {
  trackEvent('Convert', 'click', hostingType + ' Buy button');
  trackPageView('/buy', true);
  trackPageView(document.location.pathname + '/buy');
}

export function trackTryButton(hostingType) {
  trackEvent('Convert', 'click', hostingType + ' Try button');
  trackPageView('/try', true);
  trackPageView(document.location.pathname + '/try');
}

export function trackTryModal(hostingType) {
  trackEvent('Convert', 'click', hostingType + ' Try modal');
}

export function trackBuyModal(hostingType) {
  trackEvent('Convert', 'click', hostingType + ' Buy modal');
}

export function trackGetItNow() {
  trackEvent('Convert', 'click', 'Get it now');
}

export function trackGetItNowModal() {
  trackEvent('Convert', 'click', 'Get it now modal');
}

export function trackVendorSupportLinkClick(name) {
  trackEvent('VendorSupport', 'click', name);
}

function trackNavClickEvent(url, name, skipPageView) {
  trackEvent('Navigation', 'click', name);
  if (!skipPageView) {
    trackPageView(url);
  }
}

function trackReportingNavClickEvent(url, name) {
  trackEvent('VendorReporting', 'navigate', name);
  trackPageView(url);
}

function trackFilterValues(filters, doTrackEvent) {
  filters.forEach(f => {
    let value;
    if (f.value === undefined) {
      value = 'cleared';
    } else if (Array.isArray(f.value)) {
      value = f.value.length ? '[' + f.value + ']' : 'cleared';
    } else {
      value = f.value + '';
    }
    doTrackEvent(f.key, value);
  });
}

function trackReportingFiltersChangeEvent(url, subTabKey, filters) {
  trackFilterValues(filters, (filterKey, filterValue) => {
    trackEvent('VendorReporting', 'filter/' + subTabKey + '/' + filterKey, filterValue);
  });
  trackPageView(url);
}

function trackReportingClearAllFiltersEvent(url, subTabKey) {
  trackEvent('VendorReporting', 'filter/' + subTabKey + '/all', 'cleared');
  trackPageView(url);
}

function trackReportingPaginationChangeEvent(url, subTabKey, offset) {
  trackEvent(
    'VendorReporting',
    'pagination/' + subTabKey,
    offset === undefined ? 'cleared' : offset
  );
  trackPageView(url);
}

function trackReportingQuickFilterEvent(url, subTabKey, filters) {
  trackFilterValues(filters, (filterKey, filterValue) => {
    trackEvent('VendorReporting', 'quick-filter/' + subTabKey + '/' + filterKey, filterValue);
  });
  trackPageView(url);
}

function trackReportingDrilldownEvent(url, currentSubTabKey, subTabKey) {
  trackEvent('VendorReporting', 'drilldown/' + currentSubTabKey, subTabKey);
  trackPageView(url);
  // TODO: also track filters set during drilldown event
}

function trackReportingExternalLinkClickEvent(externalLinkName) {
  trackEvent('VendorReporting', 'clickExternalLink', externalLinkName);
}

export function trackWizardStep(wizardUrl, stepIdx) {
  trackPageView(wizardUrl + '/step/' + stepIdx);
}

export function trackHeaderSearch(data) {
  trackEvent('Search', 'Text query search', 'Header search');
  trackEvent('Search', 'Header search', data);
}

export function trackHomepageSearchEvent(data) {
  trackEvent('Search', 'Text query search', 'Homepage search');
  trackEvent('Search', 'Homepage search', data);
}

export function trackSearchTextbox(data) {
  trackEvent('Search', 'edit query', data);
}

export function trackSearchResultClick() {
  trackEvent('Search', 'click', 'Result');
}

export function trackFacetClick(facet) {
  trackEvent('Search', 'enable/disable facet', facet);
}

export function trackFacetMultipleChange(count) {
  trackEvent('Search', 'change', 'Facet', count);
}

export function trackCategoryLinkClick() {
  trackEvent('Search', 'click', 'Single app add-on category link');
}

export function trackVendorConvertRequest(addonName) {
  trackEvent('Vendor_Convert_Request', addonName);
}

export function trackSeeMoreReviews() {
  trackEvent('Navigation', 'click', 'See more reviews');
}

export function trackLoadMore() {
  trackEvent('Navigation', 'click', 'seeMoreAddons');
}

export function trackLightboxView(imageUrl, isHighlight, cdnBase) {
  const eventName = isHighlight ? 'Highlight image' : 'Screenshot';
  trackEvent('Navigation', 'click', eventName);
  // only track pageviews for in-site resources (ie, not youtube)
  const relativizeUrl = url => url.replace(window.location.origin, '').replace(cdnBase, '');

  const relativeUrl = relativizeUrl(imageUrl);

  if (relativeUrl.match(/^\/[^/].*$/)) {
    trackPageView(relativeUrl);
  }
}

export function trackSimilarAddon() {
  trackEvent('Navigation', 'click', 'Similar add-on');
}

export function trackSlide(dataToTrack) {
  trackEvent('Navigation', 'slide', dataToTrack);
}

export function trackWatchAction(verb) {
  trackEvent('Convert', 'click', verb + ' add-on');
}

let alreadyTrackedVerfifiedHover = false;

export function trackVerifiedHover() {
  if (!alreadyTrackedVerfifiedHover) {
    trackEvent('Navigation', 'hover', 'Verified badge');
    trackPageView(document.location.pathname + '#verified-badge-hover');
    alreadyTrackedVerfifiedHover = true;
  }
}

export function trackVerifiedClick() {
  trackEvent('Navigation', 'click', 'Verified badge');
  trackPageView(document.location.pathname + '#verified-badge-click');
}

export function trackFooterChartsClick(data) {
  trackEvent('Navigation', 'click', 'Footer ' + data);
}

export function contentGroupHosting(data) {
  setContentGroup(contentGroupHostingIndex, data);
}

export function contentGroupCompatibleProduct(data) {
  setContentGroup(contentGroupCompatibleProductIndex, data);
}

export function contentGroupPaymentModel(data) {
  setContentGroup(contentGroupPaymentModelIndex, data);
}

export function trackUserActionClicked(actionText) {
  trackEvent('HeaderUserActions', 'click', actionText);
}

export function trackHelpActionClicked(actionText) {
  trackEvent('HeaderHelpActions', 'click', actionText);
}

export const SOLUTIONS_CATEGORY = 'DiscoveryLanding';
export const DISCOVER_PERSPECTIVE_CATEGORY = 'DiscoveryExplore';

export function trackSolutionsTileMounted(solution, addonKey, hitRank) {
  trackEvent(SOLUTIONS_CATEGORY, 'viewTile/landingTile/' + solution, addonKey, hitRank);
}

export function trackSolutionsLargeCuratedTileMounted(solution, addonKey, hitRank) {
  trackEvent(SOLUTIONS_CATEGORY, 'viewTile/landingLargeCuratedTile/' + solution, addonKey, hitRank);
}

export function trackSolutionsSmallCuratedTileMounted(solution, addonKey, hitRank) {
  trackEvent(SOLUTIONS_CATEGORY, 'viewTile/landingSmallCuratedTile/' + solution, addonKey, hitRank);
}

export function trackSolutionsLoadMoreClick(solution) {
  trackEvent(SOLUTIONS_CATEGORY, 'viewMore', solution);
}

export function trackCategoryTileClicked(category) {
  trackEvent(DISCOVER_PERSPECTIVE_CATEGORY, 'clickTile/category', category);
}

export function trackLookingForDataCenter() {
  trackEvent('Navigation', 'click', 'Looking for Data Center');
}

export const addVendorGAId = registerTrackerAndPluginVars;
export const removeVendorGAId = unregisterTrackerAndPluginVars;
export const trackTabChange = trackNavClickEvent;
export const trackReportingSubTabChange = trackReportingNavClickEvent;
export const trackReportingFiltersChange = trackReportingFiltersChangeEvent;
export const trackReportingClearAllFilters = trackReportingClearAllFiltersEvent;
export const trackReportingPaginationChange = trackReportingPaginationChangeEvent;
export const trackReportingExternalLinkClick = trackReportingExternalLinkClickEvent;
export const trackReportingDrilldown = trackReportingDrilldownEvent;
export const trackReportingQuickFilter = trackReportingQuickFilterEvent;
export const trackDownloadLink = trackPageView;
